'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';
import { ToastContainer } from './toast';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);

    const addToast = useCallback(({ title, description, type = 'default', duration = 5000, action }) => {
        const id = Math.random().toString(36).substr(2, 9);
        setToasts((prev) => [...prev, { id, title, description, type, duration, action }]);
    }, []);

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);

    const toast = {
        success: (title, options) => addToast({ ...options, title, type: 'success' }),
        error: (title, options) => addToast({ ...options, title, type: 'error' }),
        warning: (title, options) => addToast({ ...options, title, type: 'warning' }),
        info: (title, options) => addToast({ ...options, title, type: 'info' }),
        message: (title, options) => addToast({ ...options, title, type: 'default' }),
        custom: (options) => addToast(options),
    };

    return (
        <ToastContext.Provider value={toast}>
            {children}
            <ToastContainer toasts={toasts} removeToast={removeToast} />
        </ToastContext.Provider>
    );
}

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
